import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteTransactionCategory(id) {
  const queryClient = useQueryClient()
  const action = async () => {
    const response = await httpClient.delete(`/team/transaction-category/${id}`)
    return response.data
  }

  return useMutation({
    mutationFn: action,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['transaction-categories'] })
      toast.success('Category deleted successfully')
    },
    onError: (error) => {
      console.error('Error deleting category:', error)
      toast.error(
        error?.response?.data?.message ?? 'Could not delete the category.',
      )
    },
  })
}
